// 取り込みの不備を伝える案内文へ、取り込んだ値をそのまま埋め込むときの切り詰め。
//
// 取り込みの1セルは最大2000万文字まで受け付けるため、値をそのまま案内文へ入れると
// 画面に出せない長さの文言ができあがり、不備の一覧を開いた利用者の操作が止まってしまう。
// 原因を見分けられる長さだけを残し、省略したことと元の文字数を添えて伝える。
//
// サーバー側 okumura-traceability-api の src/domain/masterImport/valueText.ts と
// 同じ上限・同じ言い回しに揃えている。取り込みの不備をどちらの画面で見ても
// 同じ見え方になるようにするため。

// 案内文へそのまま埋め込んでよい文字数。これを超える値は先頭だけを残す。
// 100文字あれば、どの値のことを指しているかを利用者が見分けられる。
export const MAX_EMBEDDED_VALUE_LENGTH = 100;

// 案内文へ埋め込める長さに整えた値。
// 文字数はサロゲートペアを1文字として数え、絵文字などの途中で切れないようにする。
export function embeddedValueTextOf(value: string): string {
  const characters = Array.from(value);
  const isOverLimit = characters.length > MAX_EMBEDDED_VALUE_LENGTH;
  if (isOverLimit) {
    const head = characters.slice(0, MAX_EMBEDDED_VALUE_LENGTH).join("");
    return `${head}…(先頭${MAX_EMBEDDED_VALUE_LENGTH}文字だけを表示しています。全${characters.length}文字)`;
  }
  return value;
}
